import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";
export default {
    query(query) {
        return http({
            url: '/api/swyl/v1/domestic/userReceDomestic/selectPage',
            method: 'post',
            params: query
        });
    },
    search(query) {
        return http({
            url: '/api/swyl/v1/domestic/userReceDomestic/conditionalSearch',
            method: 'post',
            params: query
        });
    },
    downloadExcel(c) {
        updownfile.down('/api/swyl/v1/domestic/userReceDomestic/downloadExcel',c,"post","data");
    }
}